import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import store from '@/store';
import { UsuarioInterface } from '@/shared/models/usuario/usuario.interface';
import queryUtil from '@/shared/utils/query.util';
import { UsuarioFilter } from '@/shared/models/usuario/usuario.filter';
import { LancamentoInterface } from '@/shared/models/usuario/lancamento.interface';
import { LancarInterface } from '@/shared/models/usuario/lancar.interface';
import { instanciaAxios } from './base.service';

const pathBase = 'usuario-externo';

export default class UsuarioAppService {
  async getExtratoSimplificadoComFiltros(filtro: UsuarioFilter | undefined): Promise<any> {
    const query = queryUtil.getQuery(filtro);
    return await instanciaAxios
      .get(`${pathBase}/extrato-simplificado${query}`)
      .then((response: any) => {
        const lista: Array<UsuarioInterface> = response.data;
        return lista;
      })
      .catch((error: any) => {
        let msg = error;
        if (error.response.status === 404) {
          msg = 'Nenhum usuário foi encontrado com os filtros informados';
        }
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, msg);
        console.error(error);
      });
  }

  async getExtratoCompletoComCPF(cpf: string): Promise<any> {
    return await instanciaAxios
      .get(`carteira-virtual/extrato?cpf=${cpf}`)
      .then((response: any) => {
        const lista: Array<LancamentoInterface> = response.data;
        return lista.filter((value) => !value.estornado);
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async getSaldoComCPF(cpf: string): Promise<any> {
    return await instanciaAxios
      .get(`carteira-virtual/saldo?cpf=${cpf}`)
      .then((response: any) => response.data)
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async getDadosComCPF(cpf: string): Promise<any> {
    return await instanciaAxios
      .get(`${pathBase}?cpf=${cpf}`)
      .then((response: any) => {
        const lista: Array<UsuarioInterface> = response.data;
        return lista[0] !== null ? lista[0] : null;
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async atualizarDados(body: UsuarioInterface): Promise<any> {
    if (body.cpf) {
      await instanciaAxios
        .put(`${pathBase}`, body)
        .then(() => {
          store.dispatch(
            MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS,
            'Usuário editado com sucesso!',
          );
        })
        .catch((error: any) => {
          console.error(error.response);
          store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
          return Promise.reject();
        });
    }
  }

  async resetarSenha(cpf: string): Promise<any> {
    await instanciaAxios
      .put(`${pathBase}/resetar-acesso/${cpf}`)
      .then(() => {
        store.dispatch(
          MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS,
          'Senha resetada com sucesso!',
        );
      })
      .catch((error: any) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }

  async resetarCreditos(cpf: string): Promise<any> {
    return await instanciaAxios
      .delete(`carteira-virtual/resetar-creditos/${cpf}`)
      .then(() => {
        store.dispatch(
          MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS,
          'Todos os créditos do usuário foram deletados com sucesso!',
        );
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async sincronizarCreditos(cpf: string): Promise<any> {
    return await instanciaAxios
      .put(`carteira-virtual/${cpf}/atualizar`)
      .then(() => {
        store.dispatch(
          MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS,
          'Os créditos do usuário foram sincronizados com sucesso!',
        );
      })
      .catch((error: any) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async lancamentoManual(body: LancarInterface): Promise<any> {
    console.log(body);
    return await instanciaAxios
      .post('carteira-virtual/lancar', body)
      .then(() => {
        store.dispatch(
          MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS,
          'Lançamento manual realizado com sucesso!',
        );
      })
      .catch((error: any) => {
        let msg = error;
        if (error.response.status === 409) {
          msg = 'Usuário com saldo insuficiente!';
        }
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, msg);
        console.error(error);
      });
  }
}
